<script>
  import {
    fetchUserBackendConfig,
    fetchUserFrontendConfig,
    fetchUserAppConfig,
    saveUserBackendConfig,
    saveUserFrontendConfig,
    saveUserAppConfig,
  } from "../utils/configApi.js";

  import Configuration from "../components/Configuration.svelte";
  import WidgetPreview from "../components/previews/WidgetPreview.svelte";
  import FeaturesSwitcher from "../components/FeaturesSwitcher.svelte";
  import CtaPreview from "../components/previews/CtaPreview.svelte";
  import ToastPreview from "../components/previews/ToastPreview.svelte";
  import NotificationForm from "../components/NotificationForm.svelte";
  import CarouselPreview from "../components/previews/CarouselPreview.svelte";
  import { notifications, Toggle, LogoLoader } from "@shopboxai/sb-portal-components";

  let backendConfigs;
  let frontendConfigs;
  let appConfigs;
  let show_save = false;
  let saving = false;
  let config = {
    backend: {
      filters: {},
    },
    frontend: {
      locale: { code: {} },
    },
    appConfig: {
      mobile: {
        notifications: [],
        notificationsEnabled: false,
      },
    },
  };
  const _fetchUserBackendConfig = async () => {
    backendConfigs = await fetchUserBackendConfig();
    config.backend.filters = { ...(backendConfigs.filters || {}) };
    if (!config.backend.filters.brand) {
      config.backend.filters.brand = "";
    }
    config.backend.price_restrict = backendConfigs.price_restrict || 0;
  };

  const _fetchUserFrontendConfig = async () => {
    frontendConfigs = await fetchUserFrontendConfig();

    config.frontend.logo = frontendConfigs.logo;
    config.frontend.maincolor = frontendConfigs.maincolor;
    config.frontend.powered_by = frontendConfigs.powered_by;
    config.frontend.locale.code = JSON.parse(frontendConfigs.locale?.code || "{}");
  };
  const _fetchUserAppConfig = async () => {
    appConfigs = await fetchUserAppConfig();

    config.appConfig.mobile = appConfigs.mobile.default;
    config.appConfig.desktop = appConfigs.desktop.default;

    if (config.appConfig.mobile.notifications == null) {
      config.appConfig.mobile.notifications = [{}];
    }
  };

  let runFetchUserBackendConfig;
  let runFetchUserFrontendConfig;
  let runFetchUserAppConfig;

  const fetchData = () => {
    show_save = false;
    runFetchUserBackendConfig = _fetchUserBackendConfig();
    runFetchUserFrontendConfig = _fetchUserFrontendConfig();
    runFetchUserAppConfig = _fetchUserAppConfig();
  };

  const saveData = async () => {
    saving = true;
    if (!backendConfigs.filters && config.backend.filters) {
      backendConfigs.filters = {};
    }

    if (backendConfigs.filters?.brand || config.backend.filters.brand) {
      if (typeof config.backend.filters?.brand == "string") {
        backendConfigs.filters.brand = config.backend.filters?.brand.split(",");
      }
    }
    if (backendConfigs.filters?.age || config.backend.filters.age) {
      backendConfigs.filters.age = config.backend.filters.age;
    }
    if (backendConfigs.filters?.size || config.backend.filters.size) {
      backendConfigs.filters.size = config.backend.filters.size;
    }
    if (backendConfigs.filters?.stock || config.backend.filters.stock) {
      backendConfigs.filters.stock = config.backend.filters.stock;
    }
    if (config.backend.price_restrict || backendConfigs.price_restrict) {
      backendConfigs.price_restrict = config.backend.price_restrict;
    }

    if (config.frontend.logo || frontendConfigs.logo) {
      frontendConfigs.logo = config.frontend.logo;
    }
    if (config.frontend.maincolor || frontendConfigs.maincolor) {
      frontendConfigs.maincolor = config.frontend.maincolor;
    }
    if (config.frontend.powered_by || frontendConfigs.powered_by) {
      frontendConfigs.powered_by = config.frontend.powered_by;
    }

    if (!frontendConfigs.locale?.code) {
      frontendConfigs.locale = {
        lang: "JSON",
      };
    }
    frontendConfigs.locale.code = JSON.stringify(config.frontend.locale.code);

    if (config.appConfig.mobile.homepage && config.appConfig.desktop.homepage) {
      appConfigs.mobile.default.homepage = config.appConfig.mobile.homepage;
      appConfigs.desktop.default.homepage = config.appConfig.desktop.homepage;
    }
    if (config.appConfig.mobile.productGrid && config.appConfig.desktop.productGrid) {
      appConfigs.mobile.default.productGrid = config.appConfig.mobile.productGrid;
      appConfigs.desktop.default.productGrid = config.appConfig.desktop.productGrid;
    }
    if (config.appConfig.mobile.productDetails && config.appConfig.desktop.productDetails) {
      appConfigs.mobile.default.productDetails = config.appConfig.mobile.productDetails;
      appConfigs.desktop.default.productDetails = config.appConfig.desktop.productDetails;
    }
    if (config.appConfig.mobile.cart && config.appConfig.desktop.cart) {
      appConfigs.mobile.default.cart = config.appConfig.mobile.cart;
      appConfigs.desktop.default.cart = config.appConfig.desktop.cart;
    }

    if (config.appConfig.mobile.notificationsEnabled) {
      if (config.appConfig.mobile.notifications) {
        let toast = config.appConfig.mobile.notifications[0];
        if (toast.page_type == "productdetails") {
          appConfigs.mobile.default.productDetails.cta = false;
        }
        if (toast.page_type == "homepage") {
          appConfigs.mobile.default.homepage.cta = false;
        }
        appConfigs.mobile.default.notifications[0] = toast;
      }
    } else {
      delete appConfigs.mobile.default.notifications;
    }

    try {
      console.log(appConfigs);
      await saveUserBackendConfig(backendConfigs);
      await saveUserFrontendConfig(frontendConfigs);
      await saveUserAppConfig(appConfigs);
      notifications.info("Saved", 1000);
      fetchData();
    } catch (error) {
      notifications.info(error, 1000);
    }
    saving = false;
  };

  fetchData();

  const handleInput = () => {
    show_save = true;
  };

  const handleTranslationsInput = () => {
    for (const key in config.frontend.locale.code) {
      if (!config.frontend.locale.code[key]) {
        delete config.frontend.locale.code[key];
      }
    }
    show_save = true;
  };
</script>

{#await runFetchUserBackendConfig}
  <div class="loader">
    <LogoLoader />
  </div>
{:then}
  <div class="settings-wrapper">
    <section>
      <h3 class="first">Filter Options</h3>
      <Configuration title="Restricted brands" subtitle="For brands specified, only the products of the same brand will be displayed.">
        <input slot="content" type="text" placeholder="Adidas,Fila,Nike" bind:value={config.backend.filters.brand} on:input={handleInput} />
      </Configuration>
      <Configuration title="Stock" subtitle="Only products in stock will be displayed.">
        <Toggle bind:value={config.backend.filters.stock} on:input={handleInput} slot="content" />
      </Configuration>
      <Configuration title="Age" subtitle="Description of the option.">
        <Toggle bind:value={config.backend.filters.age} on:input={handleInput} slot="content" />
      </Configuration>
      <Configuration title="Size" subtitle="Display products with same size.">
        <Toggle bind:value={config.backend.filters.size} on:input={handleInput} slot="content" />
      </Configuration>

      <Configuration title="Price" subtitle="Display products within specified price range.">
        <div slot="content" class="flex range">
          <input type="range" min="0.0" max="1.0" step="0.1" bind:value={config.backend.price_restrict} on:input={handleInput} />
          <span class="range-value">{config.backend.price_restrict * 100} %</span>
        </div>
      </Configuration>
    </section>
  </div>
{:catch}
  No configs
{/await}

{#await runFetchUserAppConfig}
  <p />
{:then value}
  <div class="settings-wrapper">
    <section>
      <h3 class="features-section-heading">Features <span class="features-device">Mobile <span class="separator" /> Desktop</span></h3>

      <div class="page-features-wrapper">
        <h4>Home Page</h4>

        <FeaturesSwitcher
          name="Shopbox menu icon"
          on:input={handleInput}
          bind:valueMobile={config.appConfig.mobile.homepage.widget}
          bind:valueDesktop={config.appConfig.desktop.homepage.widget}
        />
        <FeaturesSwitcher
          name="CTA pop up"
          on:input={handleInput}
          bind:valueMobile={config.appConfig.mobile.homepage.cta}
          bind:valueDesktop={config.appConfig.desktop.homepage.cta}
        />
      </div>

      <div class="page-features-wrapper">
        <h4>Collection page</h4>
        <FeaturesSwitcher
          name="Shopbox menu icon"
          on:input={handleInput}
          bind:valueMobile={config.appConfig.mobile.productGrid.widget}
          bind:valueDesktop={config.appConfig.desktop.productGrid.widget}
        />
      </div>

      <div class="page-features-wrapper">
        <h4>Product details page</h4>
        <FeaturesSwitcher
          name="Shopbox menu icon"
          on:input={handleInput}
          bind:valueMobile={config.appConfig.mobile.productDetails.widget}
          bind:valueDesktop={config.appConfig.desktop.productDetails.widget}
        />
        <FeaturesSwitcher
          name="CTA pop up"
          on:input={handleInput}
          bind:valueMobile={config.appConfig.mobile.productDetails.cta}
          bind:valueDesktop={config.appConfig.desktop.productDetails.cta}
        />
      </div>

      {#if config.appConfig.mobile.cart && config.appConfig.desktop.cart}
        <div class="page-features-wrapper">
          <h4>Cart page</h4>
          <FeaturesSwitcher
            name="Shopbox menu icon"
            on:input={handleInput}
            bind:valueMobile={config.appConfig.mobile.cart.widget}
            bind:valueDesktop={config.appConfig.desktop.cart.widget}
          />
        </div>
      {/if}
    </section>
  </div>
  <section>
    <div class="settings-wrapper">
      <h3>Notification settings</h3>

      <NotificationForm
        bind:notificationsEnabled={config.appConfig.mobile.notificationsEnabled}
        bind:selectedPreset={config.appConfig.mobile.notifications[0]}
        on:input={handleInput}
      />
      <ToastPreview bind:toast={config.appConfig.mobile.notifications[0]} />
    </div>
  </section>
{:catch error}
  <p />
{/await}

{#await runFetchUserFrontendConfig}
  <p />
{:then}
  <div class="settings-wrapper">
    <section>
      <div class="widget-preview">
        <WidgetPreview
          color={config.frontend.maincolor}
          imgUrl={config.frontend.logo}
          sbGreeting={config.frontend.locale.code.widget_title}
          sbSlogan={config.frontend.locale.code.widget_subtitle}
          recentText={config.frontend.locale.code.recent_widget}
          similarText={config.frontend.locale.code.similar_widget}
        />
      </div>
      <h3>Widget styles</h3>
      <Configuration title="Logo" subtitle="Specify the url of your logo">
        <input slot="content" type="text" placeholder="https://mylogo.com" bind:value={config.frontend.logo} on:input={handleInput} />
      </Configuration>

      <Configuration title="Primary color" subtitle="Change the color of the header and buttons">
        <input slot="content" type="text" bind:value={config.frontend.maincolor} on:input={handleInput} />
      </Configuration>

      <!-- <Configuration title="Hide 'Powered by Shopbox'">
        <Toggle bind:value={config.frontend.powered_by} on:input={handleInput} slot="content" />
      </Configuration> -->
    </section>

    <section>
      <h3>Widget translations</h3>

      <Configuration title="Title">
        <input
          slot="content"
          type="text"
          placeholder="Hi"
          bind:value={config.frontend.locale.code.widget_title}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Subtitle">
        <input
          slot="content"
          type="text"
          placeholder="I am your personal shopping assistant"
          bind:value={config.frontend.locale.code.widget_subtitle}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recent widget">
        <input
          slot="content"
          type="text"
          placeholder="Recently Viewed Items"
          bind:value={config.frontend.locale.code.recent_widget}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Similar widget">
        <input
          slot="content"
          type="text"
          placeholder="Similar Products"
          bind:value={config.frontend.locale.code.similar_widget}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>

    <section class="cta-settings">
      <CtaPreview CtaSimilarText={config.frontend.locale.code.similar_cta} CtaRecentText={config.frontend.locale.code.recent_cta} />
      <h3>CTA pop up</h3>
      <Configuration title="Similar CTA">
        <input
          slot="content"
          type="text"
          placeholder="Want to see similar products?"
          bind:value={config.frontend.locale.code.similar_cta}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recent CTA">
        <input
          slot="content"
          type="text"
          placeholder="Products you've recently viewed"
          bind:value={config.frontend.locale.code.recent_cta}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>
    <section class="carousel-settings">
      <CarouselPreview
        similar={config.frontend.locale.code.similar_embed}
        recent={config.frontend.locale.recent_embed}
        recommended={config.frontend.locale.recommended_embed}
        boughtTogether={config.frontend.locale.frequentlyBoughtTogether_embed}
      />
      <h3>Carousel embeds</h3>
      <Configuration title="Similar products">
        <input
          slot="content"
          type="text"
          placeholder="Other products you may like"
          bind:value={config.frontend.locale.code.similar_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recently viewed">
        <input
          slot="content"
          type="text"
          placeholder="Recently viewed products"
          bind:value={config.frontend.locale.code.recent_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Recommended products">
        <input
          slot="content"
          type="text"
          placeholder="Recommended for you"
          bind:value={config.frontend.locale.code.recommended_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
      <Configuration title="Bought together">
        <input
          slot="content"
          type="text"
          placeholder="Frequently Bought Together"
          bind:value={config.frontend.locale.code.frequentlyBoughtTogether_embed}
          on:input={handleTranslationsInput}
        />
      </Configuration>
    </section>
  </div>
  <footer>
    <div class="footer-wrapper">
      <button
        class="secondary {show_save ? '' : 'hidden'}"
        on:click={() => {
          fetchData();
        }}
      >
        Discard Changes
      </button>
      <button
        class="primary"
        disabled={!show_save}
        on:click={() => {
          saveData();
        }}
      >
        {saving == true ? "Saving..." : "Save Changes"}
      </button>
    </div>
  </footer>
{:catch}
  No frontend configs
{/await}

<style>
  .page-features-wrapper {
    border-bottom: 1px solid #d0d0d2;
  }
  .page-features-wrapper h4 {
    color: var(--t-c);
    font-weight: 300;
    margin: 1em 0;
  }
  .page-features-wrapper :global(.checkbox-wrapper > label) {
    color: var(--t-c-l) !important;
    text-transform: lowercase !important;
    margin-right: 5px;
  }
  .features-section-heading {
    display: flex;
    justify-content: space-between;
  }
  .features-device {
    width: 95px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 0.75rem;
    font-weight: 100;
    color: var(--t-c-l);
  }
  .separator {
    height: 12px;
    width: 1px;
    margin: auto 0;
    background-color: #d9d9d9;
  }
  .settings-wrapper {
    max-width: 600px;
    position: relative;
  }
  .cta-settings,
  .carousel-settings {
    position: relative;
  }
  .widget-preview {
    position: sticky;
    top: 3.2em;
  }
  .flex {
    display: flex;
  }
  section {
    margin-bottom: 3em;
  }
  input[type="text"] {
    width: 50%;
    height: 60%;
    border: solid 1px #d0d0d2;
    border-radius: 3px;
    padding: 12px 8px;
  }
  .range span {
    margin-left: 10px;
  }
  h3 {
    padding-top: 1em;
    background-color: #fff;
    padding-bottom: 1em;
    color: var(--t-l-c);
    position: sticky;
    top: 50px;
    z-index: 2;
  }
  .hidden {
    display: none;
  }
  footer {
    background-color: #fff;
    border-top: 1px solid var(--brd-l);
    box-shadow:
      0px 6px 14px -6px rgba(24, 39, 75, 0.12),
      0px 10px 32px -4px rgba(24, 39, 75, 0.1);
    width: calc(100% + 2em);
    margin: 0 0 -1em -1em;
    padding: 0.5em 1em;
    position: sticky;
    bottom: 0;
    align-self: flex-end;
    z-index: 2;
  }
  .footer-wrapper > .secondary {
    border: 1px solid;
    margin-right: 1em;
  }
  .footer-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  .range-value {
    min-width: 45px;
  }
  input[type="range"] {
    -webkit-appearance: none;
    margin-top: 0.5em;
    width: 200px;
    height: 7px;
    background: var(--brd-l);
    border-radius: 15px;
  }

  input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid var(--h-c);
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid var(--h-c);
  }
  input[type="range"]::-moz-range-progress {
    background: var(--h-c);
    height: 7px;
    border-radius: 15px;
  }
  input[type="range"]::-ms-fill-lower {
    background: var(--h-c);
    border-radius: 10px;
  }
  input[type="range"]::-ms-fill-upper {
    background: #ddd;
    border-radius: 10px;
  }
  input[type="range"]::-ms-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid var(--h-c);
  }
  .loader {
    position: absolute;
    top: 400px;
    left: 50%;
    transform: translateX(-50%) scale(2);
  }

  @media (max-width: 640px) {
    h3 {
      top: 100px;
      z-index: 1;
    }
  }
  @media (max-width: 450px) {
    input[type="text"] {
      width: 100%;
      margin-top: 0.3em;
    }
    input[type="range"] {
      width: 85%;
    }
  }
</style>
